import React, { memo, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styles from './styles.module.css';
import { Button, Input } from '../../../../../common/ui';
import { createCategory } from '../../actions';
import { useNavigate } from 'react-router-dom';
import { showAlert } from '../../../../../common/actions';
import PropTypes from 'prop-types';

const AddNewCategory = memo(({ createCategory, showAlert }) => {
  const [isLoading, setLoading] = useState(false);
  const [nameError, setNameError] = useState('');
  const [categoryForm, setCategoryForm] = useState({
    name: '',
    datecreated: '',
  });
  const navigate = useNavigate();

  useEffect(() => {
    const today = new Date();
    const formatDate = `${String(today.getDate()).padStart(2, '0')}/${String(
      today.getMonth() + 1
    ).padStart(2, '0')}/${today.getFullYear()}`;
    setCategoryForm((prev) => ({ ...prev, datecreated: formatDate }));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const name = categoryForm.name?.trim() || '';
    if (!name) {
      setNameError('Please enter a category name.');
      return;
    }
    setNameError('');
    setLoading(true);
    const isSuccess = await createCategory({ ...categoryForm, name });
    setLoading(false);
    if (isSuccess) {
      showAlert({
        isAlertOpen: true,
        alertType: 'success',
        alertMessage: 'Category created successfully.',
      });
      navigate('/inventory/categories');
    } else {
      showAlert({
        isAlertOpen: true,
        alertType: 'danger',
        alertMessage: 'Operation failed. Please try again later.',
      });
    }
  };

  const handleCancel = () => {
    navigate('/inventory/categories');
  };

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1 className={styles.pageTitle}>New Category</h1>
      </header>
      <div className={styles.body}>
        <form onSubmit={handleSubmit} noValidate className={styles.formCard}>
          <div className={styles.formSection}>
            <div className={styles.fieldGroup}>
              <Input
                label="Name"
                type="text"
                value={categoryForm.name}
                onChange={(value) => {
                  setCategoryForm((prev) => ({ ...prev, name: value }));
                  if (nameError) setNameError('');
                }}
                placeholder="Category name"
                error={nameError}
              />
            </div>
            <div className={styles.fieldGroup}>
              <Input
                label="Created Date"
                type="text"
                value={categoryForm.datecreated}
                disabled
              />
            </div>
          </div>
          <div className={styles.buttonPanel}>
            <Button type="submit" disabled={isLoading}>
              {isLoading ? 'Loading...' : 'Submit'}
            </Button>
            <Button type="button" variant="secondary" onClick={handleCancel}>
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
});

AddNewCategory.propTypes = {
  createCategory: PropTypes.func.isRequired,
  showAlert: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  categoriesState: state.categoriesState,
});

export default connect(mapStateToProps, {
  createCategory,
  showAlert,
})(AddNewCategory);
